/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { Component, OnInit, ViewChild, DestroyRef, inject } from '@angular/core'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute } from '@angular/router'
import { ItemListaConfiguracao } from 'src/app/models/item-lista-configuracao'
import { ConfiguracaoService } from 'src/app/services/configuracao.service'
import { SearchInputComponent, DefaultPaginatorComponent } from 'src/app/modules/shared'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({
  selector: 'app-lista-configuracao',
  templateUrl: './lista-configuracao.component.html',
  styleUrls: ['./lista-configuracao.component.css'],
})
export class ListaConfiguracaoComponent implements OnInit {
  private destroyRef = inject(DestroyRef)

  @ViewChild('paginator') paginator!: DefaultPaginatorComponent
  @ViewChild(MatSort) sort!: MatSort
  @ViewChild('searchInput') searchInput!: SearchInputComponent

  colunasGrid: string[] = ['id', 'campus', 'chave', 'valor', 'action']
  dataSource: MatTableDataSource<ItemListaConfiguracao> = new MatTableDataSource()

  constructor(private configuracaoService: ConfiguracaoService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.route.snapshot.url[0].toString() == 'gerencia-configuracao')
      this.configuracaoService.listarGerencia().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(configuracoes => this.carregarDataSource(configuracoes))
    else this.configuracaoService.listarRHeFinancas().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(configuracoes => this.carregarDataSource(configuracoes))
  }

  carregarDataSource(configuracoes: ItemListaConfiguracao[]) {
    this.dataSource = new MatTableDataSource(configuracoes)
    this.dataSource.sort = this.sort
    this.dataSource.paginator = this.paginator.matPaginator
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  formataValor(chave: string, valor: string): string {
    if (chave == 'CPF_RESTRITO' || chave == 'RG_RESTRITO') {
      return valor.split(',').sort().join(' ')
    } else return valor
  }
}
